@if (message) {
  <div #alert class="alert alert-{{ type }} alert-dismissible fade show text-center" role="alert">
    <button type="button" class="btn-close" aria-label="Close" (click)="closeAlert()"></button>
    <div>
      {{ message | translate }}
      @if (detail) {
        <a mdbPopover="{{ detail }}" mdbPopoverTitle="Détail de l'erreur" trigger="focus" tabindex="0" color="primary"
          ><mat-icon>info_circle</mat-icon></a
        >
      }
    </div>
    @if (showMailSupport) {
      <div>
        <a [href]="supportEmailLink">{{ supportText }}</a>
      </div>
    }
  </div>
}
